import React, { useEffect, useState } from "react";

import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import Grid from "../../lib/components/grid";
import { GridColumns } from "./invoicevsdetailsgridsetup";
import { systemstabilityinvoicevsdetails } from "../../lib/api/systemstability";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(1),
    },
  });

type InvoiceVsDetailsGridProps = {} & WithStyles<typeof styles>;

const InvoiceVsDetailsGridUnstyled: React.FC<InvoiceVsDetailsGridProps> = () => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const loadData = async () => {
    setLoading(true);
    const result = await systemstabilityinvoicevsdetails();
    setData(result);
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div>
      <Grid data={data} loading={loading} GridColumns={GridColumns} clearFilters={"systemstabilityinvoicevsdetails"} handleRefresh={loadData} />
    </div>
  );
};

export default withStyles(styles)(InvoiceVsDetailsGridUnstyled);
